module.exports = __webpack_public_path__ + "c75fa46fff7861fe557c73484ca66c40.png";